import PropTypes from 'prop-types'
import Imagen from '../../imagen/Imagen'
import Precios from '../../reutilizables/precios/Precios'
import styles from './Publicacion.module.css'

const Publicacion = ({ publicacion, onClick, adjunto, loadingImagenes }) => {
  const simbolo = publicacion.monedaSimbolo ?? publicacion.monSimb ?? ''
  const codigo = publicacion.monCod ?? ''
  const precio = publicacion.precioUnitario ?? publicacion.precio ?? 0
  const esNuevo = publicacion.nuevo || publicacion.esNuevo

  return (
    <div
      className={styles.card}
      onClick={() => onClick(publicacion.idPublicacion, publicacion.idVendedor)}
    >
      <div className={styles.imagen}>
        <Imagen
          width="100%"
          height="100%"
          idPublicacion={publicacion.idPublicacion}
          adjunto={adjunto}
          loadingImagenes={loadingImagenes}
        />
      </div>

      <div className={styles.info}>
        <p className={styles.titulo}>{publicacion.titulo}</p>
        <Precios
          precio={precio}
          monedaSimbolo={`${simbolo}${codigo ? ` ${codigo} ` : ' '}`}
          alicuota={publicacion.alicuota || 0}
          className={styles.precio}
        />
        <div className={styles.badges}>
          <span className={`${styles.badge} ${esNuevo ? styles.badgeNuevo : styles.badgeUsado}`}>
            {esNuevo ? 'Nuevo' : 'Usado'}
          </span>
          {publicacion.scrap && (
            <span className={`${styles.badge} ${styles.badgeScrap}`}>
              <i className="bi bi-recycle me-1" />
              Scrap
            </span>
          )}
        </div>
      </div>

      <i className={`bi bi-chevron-right ${styles.chevron}`} />
    </div>
  )
}

Publicacion.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    clase: PropTypes.string,
    titulo: PropTypes.string.isRequired,
    monedaSimbolo: PropTypes.string,
    monSimb: PropTypes.string,
    monCod: PropTypes.string,
    precioUnitario: PropTypes.number,
    precio: PropTypes.number,
    nuevo: PropTypes.bool.isRequired,
    scrap: PropTypes.bool,
    idVendedor: PropTypes.number,
    esNuevo: PropTypes.bool,
    alicuota: PropTypes.number
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  adjunto: PropTypes.shape({
    url: PropTypes.string,
    nombre: PropTypes.string
  }),
  loadingImagenes: PropTypes.bool.isRequired
}

export default Publicacion
